<template>
  <v-container
    id="data-tables"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        class="mt-5"
      >
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col
                cols="12"
                class="text-h6"
              >
                <v-chip
                  class="mx-5"
                  color="primary"
                >
                  Начисления
                </v-chip>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col
        cols="12"
      >
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="headers.filter(a=>a.show || a.active)"
              :items="items"
              multi-sort
              :footer-props="datatable_footer"
              :server-items-length="total"
              :options.sync="table_options"
              :loading="loading"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:top>
                <v-card flat>
                  <v-card-text>
                    <v-row dense>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-text-field
                          v-model="form.search"
                          clearable
                          outlined
                          label="Поиск"
                          prepend-inner-icon="mdi-magnify"
                          dense
                          @keyup.enter="load"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-btn
                          color="primary"
                          outlined
                          @click="filter_dialog = true;"
                        >
                          <v-icon class="ml-3">
                            mdi-filter-variant
                          </v-icon>
                          <span class="mx-3">ФИЛЬТРЫ</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        class="text-right d-none d-md-block"
                        md="6"
                      >
                        <v-btn
                          v-if="$store.state.access[19][5] && false"
                          color="primary"

                          @click="$router.push('/admin/order/create')"
                        >
                          <v-icon class="ml-3">
                            mdi-plus
                          </v-icon>
                          <span class="mx-3">Добавить</span>
                        </v-btn>
                        <v-btn
                          v-if="$store.state.access[19][5]"
                          color="secondary"
                          outlined
                          class="ml-5"
                          @click="report"
                        >
                          <v-icon class="ml-3">
                            mdi-download
                          </v-icon>
                          <span class="mx-3">Выгрузить</span>
                        </v-btn>
                        <v-icon
                          medium
                          class="icon-table"
                          @click="show_header_dialog"
                        >
                          mdi-table-cog
                        </v-icon>
                      </v-col>
                      <v-col
                        cols="12"
                        class="d-md-none"
                      >
                        <v-btn
                          v-if="$store.state.access[19][5] && false"
                          color="primary"
                          @click="$router.push('/admin/order/create')"
                        >
                          <v-icon class="ml-3">
                            mdi-plus
                          </v-icon>
                          <span class="mx-3">Добавить</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        class="d-md-none"
                      >
                        <v-btn
                          v-if="$store.state.access[19][5]"
                          color="secondary"
                          outlined
                          @click="report"
                        >
                          <v-icon class="ml-3">
                            mdi-download
                          </v-icon>
                          <span class="mx-3">Выгрузить</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        class="mt-n5"
                      >
                        <div v-if="filter.set">
                          <div
                            v-for="(tab, index) in filter_fields"
                            :key="'tab_f' + index"
                          >
                            <v-chip
                              v-for="(filter, index2) in tab.data.filter(a=>a.value ||a.value ===0 || a.from || a.to || a.max || a.min || a.max || a.min)"
                              :key="'data_f' + index2"
                              color="grey lighten-2"
                              class="ma-1"
                              close
                              @click:close="clear_filter_value(filter)"
                            >
                              <span v-if="filter.type == 'date'">{{ filter.name }}: {{ format(filter.from) }}/{{ format(filter.to) }}</span>
                              <span v-else-if="filter.type == 'number'">{{ filter.name }}: {{ (filter.min) }}/{{ (filter.max) }}</span>
                              <span v-else-if="filter.type == 'select'">{{ filter.name }}: {{ filter.select.filter(a=>a.value == filter.value)[0].text }}</span>
                              <span v-else>{{ filter.name }}: {{ filter.value }}</span>
                            </v-chip>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
              <template v-slot:item.state="{item}">
                <v-chip :color="get_state_color(item.state)">
                  {{ dict.state[item.state] }}
                </v-chip>
              </template>
              <template v-slot:item.sum.full="{item}">
                {{ Number(item.sum.full).money() }}
              </template>
              <template v-slot:item.sum.comission="{item}">
                {{ Number(item.sum.comission).money() }}
              </template>
              <template v-slot:item.sum.recipient="{item}">
                {{ Number(item.sum.recipient).money() }}
              </template>
              <template v-slot:item.sum.paid="{item}">
                {{ Number(item.sum.paid).money() }}
              </template>
              <template v-slot:item.action="{ item }">
                <v-menu
                  :close-on-content-click="false"
                  :nudge-width="100"
                  :nudge-bottom="12"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs, value }">
                    <v-btn
                      v-bind="attrs"
                      color="primary"
                      text
                      v-on="on"
                      @click="sheetitem = item"
                    >
                      <v-icon
                        large
                        class="beg_triangle"
                      >
                        mdi-menu-open
                      </v-icon>
                    </v-btn>
                  </template>

                  <v-card>
                    <v-list>
                      <v-list-item
                        v-if="$store.state.access[19][3] || $store.state.access[19][4] && sheetitem.creator && sheetitem.creator.id == $store.state.user.id"
                        @click="cancel(sheetitem)"
                      >
                        <v-list-item-content>
                          Отменить
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="$router.push('/common/payment/list?order=' + sheetitem.id)">
                        <v-list-item-content>
                          Список платежей
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="show_mfc_form(sheetitem)">
                        <v-list-item-content>
                          Открыть форму заказа
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </template>
              <template v-slot:item.name="{item}">
                <span v-if="item">
                  {{ item.surname }} {{ item.name }} {{ item.patronymic }}
                </span>
              </template>
              <template v-slot:item.phones="{item}">
                <div v-if="item.phones && item.phones.length > 0">
                  <span
                    v-for="(phone, index) in item.phones"
                    :key="index"
                  >
                    {{ phone.number }}<br>
                  </span>
                </div>
              </template>
              <template v-slot:item.created="{ item }">
                <span v-if="item && item.created">
                  {{ format_date(item.created) }}
                </span>
              </template>
              <template v-slot:item.updated="{ item }">
                <span v-if="item && item.updated">
                  {{ format_date(item.updated) }}
                </span>
              </template>
              <template v-slot:item.creator="{ item }">
                <span v-if="item && item.creator">
                  {{ item.creator.surname }} {{ item.creator.name }} {{ item.creator.patronymic }}
                </span>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
        <v-bottom-sheet v-model="sheet">
          <v-list>
            <v-list-group v-model="sheetmenu">
              <v-list-tile slot="activator">
                <v-list-tile-action>
                  <v-icon>mdi-build</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Действия</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-item @click="$router.push('/admin/order/view?id=' + sheetitem.id)">
                <v-list-item-content>
                  Открыть
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="$store.state.access[19][3] || $store.state.access[19][4] && sheetitem.creator && sheetitem.creator.id == $store.state.user.id"
                @click="$router.push('/admin/order/change?id=' + sheetitem.id)"
              >
                <v-list-item-content>
                  Изменить
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="$store.state.access[19][3] || $store.state.access[19][4] && sheetitem.creator && sheetitem.creator.id == $store.state.user.id"
                @click="DeleteItem(sheetitem)"
              >
                <v-list-item-content>
                  Удалить
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-bottom-sheet>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="filter_dialog"
        persistent
        max-width="900px"
      >
        <base-material-card
          color="primary"
          icon="mdi-filter-outline"
          inline
          class="filter_popup"
        >
          <v-card-title>
            <span class="text-h5">Фильтры</span>
          </v-card-title>
          <v-card-text>
            <v-tabs
              v-model="tab_index"
              vertical
            >
              <v-tab
                v-for="(tab, index) in filter_fields"
                :key="index"
              >
                <div class="filter_row">
                  {{ tab.name }}
                  <v-btn
                    icon
                    @click="setFavouriteTab(tab.index)"
                  >
                    <v-icon
                      left
                      :class="[{'active': $store.state.user.tab_item == tab.index}]"
                    >
                      mdi-star
                    </v-icon>
                  </v-btn>
                </div>
              </v-tab>

              <v-tab-item
                v-for="(tab, index) in filter_fields"
                :key="index"
              >
                <v-card flat>
                  <v-card-text>
                    <div
                      v-for="(field, index2) in tab.data"
                      :key="'i_'+index2"
                    >
                      <v-select
                        v-if="field.type=='select'"
                        v-model="field.value"
                        clearable
                        :label="field.name"
                        :items="field.select"
                        @change="filter.changed = true"
                      />
                      <div
                        v-else-if="field.type=='date'"
                        clearable
                        :label="field.name"
                        :items="field.select"
                      >
                        <v-row>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-select
                              v-model="field.date_select"
                              clearable
                              :label="field.name"
                              :items="[{value:'yesterday', text:'Вчера'},{value:'today', text:'Сегодня'},{value:'tomorrow', text:'Завтра'},{value:'date', text:'Конкретная дата'},{value:'period', text:'Период дат'}]"
                              @change="changeFilterDateType($event, index , field)"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-model="field.from"
                              :label="field.date_select == 'period' ? 'От' : 'Конкретная дата'"
                              :disabled="field.date_select !== 'period' && field.date_select !== 'date'"
                              type="date"
                              :max="max_date"
                              @input="filter.changed = true"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-if="field.date_select == 'period'"
                              v-model="field.to"
                              label="До"
                              type="date"
                              :max="max_date"
                              @input="filter.changed = true"
                            />
                          </v-col>
                        </v-row>
                      </div>
                      <div v-else-if="field.type=='number'">
                        <v-row>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              :label="field.name"
                              readonly
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-model="field.min"
                              label="От"
                              type="number"
                              @input="filter.changed = true"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-model="field.max"
                              label="До"
                              type="number"
                              @input="filter.changed = true"
                            />
                          </v-col>
                        </v-row>
                      </div>
                      <v-text-field
                        v-else
                        v-model="field.value"
                        :label="field.name"
                        :type="field.type"
                        @input="filter.changed = true"
                      />
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              width="80"
              color="primary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-primary"
              @click="filter_dialog = false, set_filter()"
            >
              <span class="mx-10">Применить</span>
            </v-btn>
            <v-btn
              width="80"
              color="secondary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-secondary"
              @click="filter_dialog = false"
            >
              <span class="mx-10">Закрыть</span>
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-dialog>
      <v-dialog
        v-model="dialog.headers.show"
        persistent
        max-width="900px"
      >
        <base-material-card
          color="primary"
          icon="mdi-table-cog"
          inline
          class="filter_popup"
        >
          <v-card-title>
            <span class="text-h5">Настройка столбцов</span>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :items-per-page="5"
              dense
              :items="headers.filter(a=>!a.show)"
              :headers="[{value: 'text', text: 'Название столбца'}, {value: 'active_temp', text: 'Отображение'}]"
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:item.active_temp="{item}">
                <v-checkbox v-model="item.active_temp" />
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              width="80"
              color="primary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-primary"
              @click="dialog.headers.show = false, set_headers()"
            >
              <span class="mx-10">Сохранить</span>
            </v-btn>
            <v-btn
              width="80"
              color="secondary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-secondary"
              @click="dialog.headers.show = false"
            >
              <span class="mx-10">Закрыть</span>
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-dialog>
      <v-dialog
        v-model="dialog.order.show"
        persistent
      >
        <mfc-order-form
          :dialog="dialog.order"
          :form="order"
          :service="order.service"
          @close="load"
          @cancel="cancel(sheetitem)"
        />
      </v-dialog>
    </v-row>
  </v-container>
</template>
<style lang="scss">
.icon-filter {
  color: grey;
  &.active {
    color:orange;
  }
  &:not(.active):hover {
    color: #315bbf;
  }
}
.icon-magnify {
  color: rgb(121, 114, 118);
  &:hover {
    color: #315bbf;
  }
}
.icon-table {
  height: 30px;
  width: 30px;
  margin-top: 3px;
  margin-left: 8px;
  color: grey;
  &:hover {
    color: #315bbf;
  }
}
.btns-edit-group {
  height: 36px!important;
  .beg_pencil {
    background-color: rgb(0, 143, 203)!important;
    border-color: rgb(24, 123, 154)!important;
    color: white;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    min-width: 50px!important;
    width: 50px!important;
    height: 36px!important;
  }
  .beg_select {
    background-color: rgb(0, 143, 203)!important;
    border-color: rgb(24, 123, 154)!important;
    color: white;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    min-width: 30px!important;
    width: 30px!important;
    height: 36px!important;

    .beg_triangle {
      transform: scale(0.36,0.22) rotate(180deg);
    }
    &.active {
      .beg_triangle {
        transform: scale(0.36,0.22) rotate(0deg);
      }
    }
  }
  .v-btn__content,
  i {
    height: 36px!important;
  }
}
/**popup */
.filter_popup .v-tabs--vertical > .v-tabs-bar .v-tab {
  display: flex;
  flex-direction: column;
  height: 80px;
  width: 140px;
  font-size: 0.6rem !important;
  line-height: 0.8rem;
  white-space: pre-wrap;
  .filter_row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .v-btn {
      height: 30px;
      width: 30px;
      margin-right: -15px;
      &:hover {
        .v-icon {
          color: rgba(0, 0, 0, 0.1);
        }
      }
      .v-icon {
        margin: 0px;
        color: rgba(0, 0, 0, 0.01);
        &.active {
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }
  }
}
@media (min-width: 960px) {
  .filter_popup .v-tabs--vertical > .v-tabs-bar .v-tab {
    flex-direction: row;
    height: 54px;
    width: 180px;
    font-size: 0.70rem !important;
    line-height: 0.8rem;
    white-space: pre-wrap;
    .filter_row {
      .v-btn {
        margin-left: 10px;
      }
    }
  }
}
/** _popup */

.search-row {
  display: flex;
  flex-direction: row;
}
.search-title {
  padding-top: 24px;
  padding-right: 10px;
  margin-top: 4px;
  font-size: 1.6rem;
  color: #ec7e2f;
}
.table_item {
  font-size: 0.929rem;
  padding-bottom: 12px;
}
.table_item:first-of-type {
  padding-top: 12px;
}

.table_item__title {
  font-size: 0.929rem;
}
.table_item__subtitle {
  font-size: 0.875rem;
  line-height: 1.2;
  color: #999;
}
</style>
<script>
  import suggest from '../../libs/suggestions.min.17.12.0.dev.js'
  import moment from 'moment'
  import $ from 'jquery'
  import mfcOrderForm from './Mfc-order-form.vue'
  import { truncate } from 'fs'
  import { parse } from 'path'
  export default {
    name: 'DashboardDataTables',
    components: { mfcOrderForm },
    data: () => ({
      table_options: {

      },
      total: 0,
      loading: false,
      tab_index: 0,
      dialog: {
        headers: {
          show: false,
        },
        order: {
          view: true,
          show: false,
        },
      },
      order: {},
      datatable_footer: {
        itemsPerPageText: 'Показывать по',
        pageText: 'из',
        itemsPerPageAllText: 'Все',
      },
      sheet: false,
      sheetmenu: true,
      sheetitem: {},
      headers: [
        {
          text: 'Действия',
          value: 'action',
          show: true,
        },
        {
          text: 'Дата/время',
          value: 'created',
          active: true,
          active_temp: false,
        },
        {
          text: 'Номер начисления',
          value: 'number',
          active: true,
          active_temp: false,
        },
        {
          text: 'Сумма начисления',
          value: 'sum.full',
          active: true,
          active_temp: false,
        },
        {
          text: 'Плательщик',
          value: 'items[0].attributes.payer_fio',
          active: true,
          active_temp: false,
        },
        {
          text: 'Номер документа',
          value: 'items[0].attributes.payer_doc_number',
          actie: true,
          active_temp: false,
        },
        {
          text: 'Получатель',
          value: 'items[0].attributes.recipient_name_full',
          active: true,
          active_temp: false,
        },
        {
          text: 'Получатель по реквизитам',
          value: 'items[0].attributes.recipient_name',
          active: true,
          active_temp: false,
        },
        {
          text: 'Статус начисления',
          value: 'state',
          active: true,
          active_temp: false,
        },
        {
          text: 'Дата/время статуса',
          value: 'updated',
          active: false,
          active_temp: false,
        },
        {
          text: 'Пользователь',
          value: 'creator',
          active: false,
          active_temp: false,
        },
        {
          text: 'Назначение платежа',
          value: 'items[0].attributes.dest',
          active: false,
          active_temp: false,
        },
        {
          text: 'Услуга',
          value: 'items[0].name',
          active: false,
          active_temp: false,
        },
        {
          text: 'ИНН получателя',
          value: 'items[0].attributes.recipient_inn',
          active: false,
          active_temp: false,
        },
        {
          text: 'Наименование получателя',
          value: 'items[0].attributes.recipient_name_full',
          active: false,
          active_temp: false,
        },
        {
          text: 'Наименование получателя по реквизитам',
          value: 'items[0].attributes.recipient_name',
          active: false,
          active_temp: false,
        },
        {
          text: 'Точка обслуживания',
          value: 'point.name',
          active: false,
          active_temp: false,
        },
        {
          text: 'Место обслуживания',
          value: 'point.place_item.address',
          active: false,
          active_temp: false,
        },
        {
          text: 'Сумма комиссии',
          value: 'sum.comission',
          active: false,
          active_temp: false,
        },
        {
          text: 'Сумма получателя',
          value: 'sum.recipient',
          active: false,
          active_temp: false,
        },
        {
          text: 'Сумма оплаченная',
          value: 'sum.paid',
          active: false,
          active_temp: false,
        },
      ],
      doc_type: {

      },
      items: [],
      form: {

      },
      search: '',
      select: {
      },
      dict: {
        state: {
          0: 'Новое',
          1: 'Частичная оплата',
          2: 'Оплачено',
          3: 'Аннулировано',
        },
      },
      filter_dialog: false,
      filter_fields: {
        common: {
          index: 0,
          name: 'Основное',
          active: true,
          data: [
            {
              name: 'Дата/время',
              data: 'created',
              type: 'date',
            },
            {
              name: 'Номер начисления',
              data: 'number',
              type: 'text',
            },
            {
              name: 'Сумма начисления',
              data: 'sum.full',
              type: 'number',
            },
            {
              name: 'Плательщик',
              data: 'items.attributes.payer_fio',
              type: 'text',
            },
            {
              name: 'Номер документа',
              data: 'items.attributes.payer_doc_number',
              type: 'text',
            },
            {
              name: 'Получатель',
              data: 'items.attributes.recipient_name_full',
              type: 'text',
            },
            {
              name: 'Получатель по реквизитам',
              data: 'items.attributes.recipient_name',
              type: 'text',
            },
            {
              name: 'Статус начисления',
              data: 'state',
              type: 'select',
              select: [
                { value: 0, text: 'Новый' },
                { value: 1, text: 'Частично оплачен' },
                { value: 2, text: 'Оплачен' },
                { value: 3, text: 'Отменен' },
              ],
            },
            {
              name: 'Дата/время статуса',
              data: 'updated',
              type: 'date',
            },
            {
              name: 'Назначение платежа',
              data: 'items.attributes.dest',
              type: 'text',
            },
            {
              name: 'Услуга',
              data: 'items.name',
              type: 'text',
            },
            {
              name: 'ИНН получателя',
              data: 'items.attributes.recipient_inn',
              type: 'text',
            },
            {
              name: 'Наименование получателя',
              data: 'items.attributes.recipient_name_full',
              type: 'text',
            },
            {
              name: 'Наименование получателя по реквизитам',
              data: 'items.attributes.recipient_name',
              type: 'text',
            },
            {
              name: 'Точка обслуживания',
              data: 'point.name',
              type: 'number',
            },
            {
              name: 'Сумма комиссии',
              data: 'sum.comission',
              type: 'number',
            },
            {
              name: 'Сумма получателя',
              data: 'sum.recipient',
              type: 'number',
            },
          ],
        },
      },
      filter: {
        set: false,
      },
    }),
    computed: {
      max_date: function () {
        return moment().format('YYYY-MM-DD')
      },
    },
    watch: {
      table_options: {
        handler () {
          console.log(this.table_options)
          this.$router.push({
            query: {
              page: this.table_options.page,
              limit: this.table_options.itemsPerPage
            }
          })
          this.load()
        },
        deep: true,
      },
    },
    mounted: function () {
      if (this.$route.query.id) {
        this.form.id = this.$route.query.id
      }

      for (const x in this.$store.state.dict.doc_type) {
        if (this.$store.state.dict.doc_type[x].type) {
          this.doc_type[this.$store.state.dict.doc_type[x].type] = Number(x)
          for (const y in this.filter_fields.documents.data) {
            if (this.filter_fields.documents.data[y].key == this.$store.state.dict.doc_type[x].type) {
              this.filter_fields.documents.data[y].extra = { data: 'type', value: Number(x) }
            }
          }
        }
      }
      this.tab_index = this.$store.state.user.tab_item
      this.load()
      this.set_default_headers()
    },
    methods: {
      show_mfc_form: function (item) {
        this.order = this.transform_order(item)
        this.dialog.order.view = true
        this.dialog.order.change = false
        this.dialog.order.create = false
        this.dialog.order.show = true
      },
      transform_order: function (data) {
        const item = data.items[0]
        const order = {
          id: data.id,
          sum: item.sum,
          service: item.id,
          recipient: {
            name: item.attributes.recipient_name,
            name_full: item.attributes.recipient_name_full,
            name_short: item.attributes.recipient_name_short,
            inn: item.attributes.recipient_inn,
            kpp: item.attributes.recipient_kpp,
            bankname: item.attributes.bank_name,
            bik: item.attributes.bank_bic,
            ks: item.attributes.bank_ks,
            accnumber: item.attributes.recipient_rs,
            oktmo: item.attributes.oktmo,
            kbk: item.attributes.kbk,
            uin: item.attributes.uin,
          },
          description: item.attributes.dest,
          payer: {
            fullname: item.attributes.payer_fio,
            address: item.attributes.payer_address,
            doc: {
              type: item.attributes.doc_type,
              series: item.attributes.payer_doc_series,
              number: item.attributes.payer_doc_number,
            },
            phone: item.attributes.payer_phone,
            email: item.attributes.payer_email,
          },
        }
        return order
        /*
        item.attributes = {
                payer_fio: form.payer.fullname,
                payer_address: form.payer.address,
                doc_type: form.payer.doc.type,
                payer_doc_series: form.payer.doc.series,
                payer_doc_number: form.payer.doc.number,
                payer_phone: form.payer.phone,
                payer_email: form.payer.email
              }
        let order = {
          client: form.client,
          items: [
            item
          ],
          member_item: form.payer,
          sum: {
            comission: Number(this.comission).toFixed(2),
            recipient: Number(form.sum).toFixed(2),
            full: (Number(form.sum) + Number(this.comission)).toFixed(2)
          }
        }
        return order */
      },
      set_default_headers: function () {
        if (!this.$store.state.user.order_headers || this.$store.state.user.order_headers.length == 0) return
        for (const x in this.headers) {
          this.headers[x].active = this.$store.state.user.order_headers.indexOf(this.headers[x].value) > -1
        }
      },
      clear_filter_value: function (field) {
        field.value = ''
        field.from = ''
        field.to = ''
        field.date_select = ''
        field.min = ''
        field.max = ''
        this.filter.changed = true
        this.set_filter()
      },
      report: function () {
        const request = JSON.parse(JSON.stringify(this.form))
        if (this.filter.set) {
          request.data = JSON.parse(JSON.stringify(this.filter_fields))
          delete request.data.set
          delete request.data.changed
        }
        request.headers = this.headers.filter(a => a.active == true).map(a => a.value)
        const form = $('<form>', {
          target: '_blank',
          action: '/api/order/export?token=' + localStorage.getItem('token'),
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: JSON.stringify(request),
            name: 'form',
          })
        )
        form.appendTo('body').submit()
      },
      get_state_color: function (state) {
        if (state == 0) return 'green'
        if (state == 1) return 'yellow'
      },
      cancel: function (item) {
        item.state = 3
        this.axios.post('/api/order/save', item)
          .then(result => {
            this.loading = false
            if (!result.data.error) {
              this.$store.commit('snackbar', 'Успешно')
              this.load()
            } else {
              this.$store.commit('snackbar', 'Ошибка при сохранении')
            }
          })
          .catch(error => {
            this.loading = false
            this.$store.commit('snackbar', 'Ошибка при сохранении')
          })
      },
      setFavouriteTab: function (index) {
        this.axios.post('/api/user/favourite_tab', { value: index, type: 'tab_item' })
          .then(result => {
            if (!result.data.error) {
              this.$store.commit('SET_FAVOURITE_TAB', { value: index, type: 'tab_item' })
            }
          })
          .catch(e => {
          })
      },
      DeleteItem: function (item) {
        this.sheet = false
        if (confirm('Вы уверены?')) {
          item.deleted = true
          this.axios.post('/api/order/save', item)
            .then(result => {
              this.loading = false
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Удаление успешно')
                this.load()
              } else {
                this.$store.commit('snackbar', 'Ошибка при удалении')
              }
            })
            .catch(error => {
              this.loading = false
              this.$store.commit('snackbar', 'Ошибка при удалении')
            })
        }
      },
      show_header_dialog: function () {
        for (const x in this.headers) {
          this.headers[x].active_temp = this.headers[x].active
        }
        this.dialog.headers.show = true
      },
      set_headers: function () {
        for (const x in this.headers) {
          this.headers[x].active = this.headers[x].active_temp
        }
        this.$axios.post('/api/user/headers', {
          entity: 'order',
          headers: this.headers.filter(a => a.active).map(a => a.value),
        })
          .catch(e => {
            console.log(e)
          })
      },
      fill_dict: function (data, dict) {
        data.select = []
        for (const x in dict) {
          data.select.push({ value: Number(x), text: dict[x].name })
        }
      },
      set_filter: function (flag) {
        if (this.filter.changed) this.filter.set = true
        this.filter.changed = false
        this.load()
      },
      clear_filter: function () {
        this.filter.set = false
        for (const x in this.filter_fields) {
          for (const y in this.filter_fields[x].data) {
            this.filter_fields[x].data[y].value = ''
            this.filter_fields[x].data[y].from = ''
            this.filter_fields[x].data[y].to = ''
          }
        }
      },
      formatInputDate: function (_date) {
        const date = new Date(_date)
        let dd = date.getDate()
        if (dd < 10) dd = '0' + dd

        let mm = date.getMonth() + 1
        if (mm < 10) mm = '0' + mm

        let yyyy = date.getFullYear()
        if (yyyy < 10) yyyy = '0' + yyyy

        return yyyy + '-' + mm + '-' + dd
      },
      changeFilterDateType (value, tab, field) {
        this.filter.changed = true
        console.log('changeFilterDateType', value, tab, field)
        if (tab && field && value) {
          if (value !== 'period' && value !== 'date') {
            let date = 0
            if (value == 'today') {
              date = new Date()
            } else if (value == 'yesterday') {
              date = new Date().setDate(new Date().getDate() - 1)
            } else if (value == 'tomorrow') {
              date = new Date().setDate(new Date().getDate() + 1)
            }
            const formated_date = this.formatInputDate(date)
            field.from = formated_date
            field.to = formated_date
          }
          if (value == 'date') {
            field.to = ''
          }
        }
      },
      format_date: function (date) {
        return moment(date).format('DD.MM.YYYY HH:mm:ss')
      },
      format: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      getDoc: function (item) {
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/document',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      clear: function () {
        this.form = {
        },
        this.load()
      },
      load: function (clear) {
        const request = JSON.parse(JSON.stringify(this.form))
        if (this.filter.set) {
          request.data = JSON.parse(JSON.stringify(this.filter_fields))
          delete request.data.set
          delete request.data.changed
        }
        this.loading = true
        const { sortBy, sortDesc, page, itemsPerPage } = this.table_options
        request.page = page
        request.limit = itemsPerPage
        this.axios.post('/api/order/list', request)
          .then(result => {
            this.loading = false
            this.form.id = null
            if (!result.data.error) {
              this.items = result.data.data
              this.total = result.data.count
            }
          })
          .catch(e => {
            this.loading = false
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
    },
  }
</script>
